import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label, EmptyItem } from "devextreme-react/form";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import { Button, ScrollView } from "devextreme-react";
import showReport from "../../showReport";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import {
  criarContribuinteDs,
  criarImovelDs,
  criarReceitasDs,
  criarTaxasDs,
} from "../../DataSources";
import ContribuinteBox from "../contribuintes/ContribuinteBox";
import ImovelBox from "../imovel/ImovelBox";
import ReceitaBox from "../receitas/ReceitasBox";
import TaxasBox from "../taxas/TaxasBox";
import { TextBox, Button as TextBoxButton } from "devextreme-react/text-box";

const template = {
  id: undefined,
  prefeituraId: undefined,
  tipoExtrato: 1,
  creditosEmAberto: 0,
  diatExtrato: 1,
  contribuinteSeq: undefined,
  imovelSeq: undefined,
  receitaId: undefined,
  taxaId: undefined,
  popupContribuinteVisivel: false,
  popupImovelVisivel: false,
  popupReceitaVisivel: false,
  popupTaxaVisivel: false,
};

function criarSysCodigoDescricoa(
  fnObterCodigo,
  fnSetCodigo,
  fnObterLegenda,
  fnPesquisa,
  fnLimpar
) {
  return function fnRender() {
    return (
      <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
        <div style={{ width: "18%", minWidth: "130px", maxWidth: "190px" }}>
          <TextBox
            value={fnObterCodigo()}
            onValueChanged={fnSetCodigo}
            showClearButton={true}
            buttons={[
              {
                name: "btnPesquisa",
                location: "after",
                options: {
                  focusStateEnabled: false,
                  icon: "search",
                  onClick: function () {
                    fnPesquisa();
                  },
                },
              },
              {
                name: "btnDelete",
                location: "after",
                options: {
                  focusStateEnabled: false,
                  icon: "remove",
                  onClick: function () {
                    fnLimpar();
                  },
                },
              },
            ]}
          />
        </div>
        <div style={{ flexGrow: "1" }}>
          <TextBox
            value={fnObterLegenda()}
            readOnly={true}
            stylingMode={"filled"}
            focusStateEnabled={false}
          />
        </div>
      </div>
    );
  };
}

export default class ExtratoDebitos extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...template, prefeituraId: UserInfo.getPrefeitura() };
    this.saidaProgramada = false;
    template.prefeituraId = UserInfo.getPrefeitura();
    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);

    this.tipoExtratoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 1, descricao: "CONTRIBUINTE" },
        { id: 2, descricao: "IMÓVEL" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
      showClearButton: false,
      onValueChanged: ({ value }) => {
        this.setState({ tipoExtrato: value });
      },
    };

    this.creditosEmAbertoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "NENHUM" },
        { id: 1, descricao: "TODOS" },
        { id: 2, descricao: "EXERCÍCIO CORRENTE" },
        { id: 3, descricao: "OUTROS EXERCÍCIOS" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.diatExtratosOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 1, descricao: "TODAS" },
        { id: 2, descricao: "ÚLTIMOS 5 ANOS" },
        { id: 3, descricao: "NENHUMA" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };
    this.contribuinteDs = criarContribuinteDs();
    this.imovelDs = criarImovelDs();
    this.receitaDs = criarReceitasDs();
    this.taxaDs = criarTaxasDs();

    //Funções do contribuinte
    /*
    /*
    */
    this.setContribuinteId = this.setContribuinteId.bind(this);
    this.pesquisarContribuinte = this.pesquisarContribuinte.bind(this);
    this.onContribuinteSelecionadoPesquisa = this.onContribuinteSelecionadoPesquisa.bind(
      this
    );
    this.contribuinteBoxRef = React.createRef();
    this.renderContribuinte = sysCodigoDescricao(
      () => this.state.contribuinteSeq,
      this.setContribuinteId,
      () => this.state._uiNomeContribuinte,
      this.pesquisarContribuinte
    );
    /*
    /*
     */
    //Fim da funções do contribuinte

    //Funções do Imovel
    /*
    /*
    */
    this.setImovelId = this.setImovelId.bind(this);
    this.pesquisarImovel = this.pesquisarImovel.bind(this);
    this.onImovelSelecionadoPesquisa = this.onImovelSelecionadoPesquisa.bind(
      this
    );
    this.renderImovel = sysCodigoDescricao(
      () => this.state.imovelSeq,
      this.setImovelId,
      () => this.state._uiNomeImovel,
      this.pesquisarImovel
    );
    /*
    /*
     */
    //Fim da funções do imovel

    //Funções da Receita
    /*
    /*
    */
    this.setReceitaId = this.setReceitaId.bind(this);
    this.pesquisarReceita = this.pesquisarReceita.bind(this);
    this.onReceitaSelecionadoPesquisa = this.onReceitaSelecionadoPesquisa.bind(
      this
    );
    this.renderReceita = criarSysCodigoDescricoa(
      () => this.state.receitaId,
      this.setReceitaId,
      () => this.state._uiNomeReceita,
      this.pesquisarReceita,
      () => this.setState({ receitaId: undefined, _uiNomeReceita: undefined })
    );
    /*
    /*
     */
    //Fim da funções do Receita

    //Funções da Taxa
    /*
    /*
    */
    this.setTaxaId = this.setTaxaId.bind(this);
    this.pesquisarTaxa = this.pesquisarTaxa.bind(this);
    this.onTaxaSelecionadoPesquisa = this.onTaxaSelecionadoPesquisa.bind(this);
    this.renderTaxa = criarSysCodigoDescricoa(
      () => this.state.taxaId,
      this.setTaxaId,
      () => this.state._uiNomeTaxa,
      this.pesquisarTaxa,
      () => this.setState({ taxaId: undefined, _uiNomeTaxa: undefined })
    );
    /*
    /*
     */
    //Fim da funções do Taxa
  }

  componentDidMount() {
    this.setState({ ...template });
  }

  //Funções do contribuinte
  /*
  /*/
  setContribuinteId({ value }) {
    this.contribuinteDs
      .load({
        filter: [["sequencial", "=", value]],
      })
      .then((result) => {
        if (result.length !== 0) {
          if (result[0] === undefined) {
            this.setState({
              _uiNomeContribuinte: "",
              popupContribuinteVisivel: false,
            });
          } else {
            this.setState({
              _uiNomeContribuinte: result[0].nome,
              contribuinteSeq: result[0].sequencial,
              popupContribuinteVisivel: false,
            });
          }
        } else {
          this.setState({ popupContribuinteVisivel: false });
        }
      })
      .catch((_) => this.setState({ _uiNomeContribuinte: "<<ERRO>>" }));
  }

  onContribuinteSelecionadoPesquisa(e) {
    let dados = { value: e.row.data.sequencial };
    this.setContribuinteId(dados);
  }

  pesquisarContribuinte() {
    this.contribuinteBoxRef.current.limparFiltro();
    this.setState({ popupContribuinteVisivel: true });
  }

  /*
   */
  //Fim da funções do contribuinte

  //Funções do imovel
  /*
  /*/
  setImovelId({ value }) {
    this.imovelDs
      .load({
        filter: [["sequencial", "=", value]],
      })
      .then((result) => {
        if (result.length !== 0) {
          if (result[0] === undefined) {
            this.setState({
              _uiNomeImovel: "",
              popupImovelVisivel: false,
            });
          } else {
            this.setState({
              _uiNomeImovel: result[0].enderecoCompleto,
              imovelSeq: result[0].sequencial,
              popupImovelVisivel: false,
            });
          }
        } else {
          this.setState({ popupImovelVisivel: false });
        }
      })
      .catch((_) => this.setState({ _uiNomeImovel: "<<ERRO>>" }));
  }

  onImovelSelecionadoPesquisa(e) {
    let dados = { value: e.row.data.sequencial };
    this.setImovelId(dados);
  }

  pesquisarImovel() {
    this.setState({ popupImovelVisivel: true });
  }

  /*
   */
  //Fim da funções do imovel

  //Funções da receita
  /*
  /*/
  setReceitaId({ value }) {
    this.receitaDs
      .load({
        filter: [["id", "=", value]],
      })
      .then((result) => {
        if (result.length !== 0) {
          if (result[0] === undefined) {
            this.setState({
              _uiNomeReceita: "",
              popupReceitaVisivel: false,
            });
          } else {
            this.setState({
              _uiNomeReceita: result[0].descricao,
              receitaId: result[0].id,
              popupReceitaVisivel: false,
            });
          }
        } else {
          this.setState({ popupReceitaVisivel: false });
        }
      })
      .catch((_) => this.setState({ _uiNomeReceita: "<<ERRO>>" }));
  }

  onReceitaSelecionadoPesquisa(e) {
    let dados = { value: e.row.data.id };
    this.setReceitaId(dados);
  }

  pesquisarReceita() {
    this.setState({ popupReceitaVisivel: true });
  }

  /*
   */
  //Fim da funções da receita

  //Funções da taxa
  /*
  /*/
  setTaxaId({ value }) {
    this.taxaDs
      .load({
        filter: [["id", "=", value]],
      })
      .then((result) => {
        if (result.length !== 0) {
          if (result[0] === undefined) {
            this.setState({
              _uiNomeTaxa: "",
              popupTaxaVisivel: false,
            });
          } else {
            this.setState({
              _uiNomeTaxa: result[0].descricao,
              taxaId: result[0].id,
              popupTaxaVisivel: false,
            });
          }
        } else {
          this.setState({ popupTaxaVisivel: false });
        }
      })
      .catch((_) => this.setState({ _uiNomeTaxa: "<<ERRO>>" }));
  }

  onTaxaSelecionadoPesquisa(e) {
    let dados = { value: e.row.data.id };
    this.setTaxaId(dados);
  }

  pesquisarTaxa() {
    this.setState({ popupTaxaVisivel: true });
  }

  /*
   */
  //Fim da funções da taxa

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form>
            <Form formData={this.state} colCount={3}>
              <GroupItem caption="EXTRATO DE DÉBITOS" colSpan={3} colCount={3}>
                <SimpleItem
                  colSpan={1}
                  dataField="tipoExtrato"
                  editorType={"dxSelectBox"}
                  editorOptions={this.tipoExtratoOptions}
                  visible={false}
                >
                  <Label text="Tipo do Extrato" />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  dataField="creditosEmAberto"
                  editorType={"dxSelectBox"}
                  editorOptions={this.creditosEmAbertoOptions}
                  visible={true}
                >
                  <Label text="Créditos em Aberto" />
                </SimpleItem>
                
                <SimpleItem
                  colSpan={1}
                  dataField="diatExtrato"
                  editorType={"dxSelectBox"}
                  editorOptions={this.diatExtratosOptions}
                >
                  <Label text="Dívida Ativa" />
                </SimpleItem>
                <EmptyItem colSpan={2}/>
                <SimpleItem
                  visible={this.state.tipoExtrato === 1 ? true : false}
                  colSpan={3}
                  component={this.renderContribuinte}
                >
                  <Label text="Contribuinte" />
                </SimpleItem>
                <SimpleItem
                  visible={this.state.tipoExtrato === 2 ? true : false}
                  colSpan={3}
                  component={this.renderImovel}
                >
                  <Label text="Imóvel" />
                </SimpleItem>
                <SimpleItem colSpan={3} component={this.renderReceita}>
                  <Label text="Receita" />
                </SimpleItem>
                <SimpleItem colSpan={3} component={this.renderTaxa}>
                  <Label text="Taxa" />
                </SimpleItem>
              </GroupItem>
            </Form>
            <div
              style={{
                marginTop: "10px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div style={{ display: "inline-block", marginRight: "10px" }}>
                <Button
                  style={{ width: "150px" }}
                  text="Cancelar"
                  onClick={this.cancel}
                />
              </div>
              <div style={{ display: "inline-block" }}>
                <Button
                  width={150}
                  text="Salvar"
                  type="success"
                  onClick={this.ok}
                />
              </div>
            </div>
          </form>
        </div>
        <Popup
          visible={this.state.popupContribuinteVisivel}
          onHiding={() => this.setState({ popupContribuinteVisivel: false })}
          dragEnabled={false}
          closeOnOutsideClick={false}
          showCloseButton={false}
          showTitle={true}
          width={"90%"}
          height={"90%"}
          title="Pesquisar Contribuinte"
        >
          <ScrollView showScrollbar={"always"}>
            <ContribuinteBox
              onSelecionado={this.onContribuinteSelecionadoPesquisa}
              ref={this.contribuinteBoxRef}
            />
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ popupContribuinteVisivel: false }),
            }}
          ></ToolbarItem>
        </Popup>
        <Popup
          visible={this.state.popupImovelVisivel}
          onHiding={() => this.setState({ popupImovelVisivel: false })}
          dragEnabled={false}
          closeOnOutsideClick={false}
          showCloseButton={false}
          showTitle={true}
          width={"90%"}
          height={"90%"}
          title="Pesquisar Imóvel"
        >
          <ScrollView showScrollbar={"always"}>
            <ImovelBox onSelecionado={this.onImovelSelecionadoPesquisa} />
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ popupImovelVisivel: false }),
            }}
          ></ToolbarItem>
        </Popup>
        <Popup
          visible={this.state.popupReceitaVisivel}
          onHiding={() => this.setState({ popupReceitaVisivel: false })}
          dragEnabled={false}
          closeOnOutsideClick={false}
          showCloseButton={false}
          showTitle={true}
          width={"90%"}
          height={"90%"}
          title="Pesquisar Receita"
        >
          <ScrollView showScrollbar={"always"}>
            <ReceitaBox onSelecionado={this.onReceitaSelecionadoPesquisa} />
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ popupReceitaVisivel: false }),
            }}
          ></ToolbarItem>
        </Popup>
        <Popup
          visible={this.state.popupTaxaVisivel}
          onHiding={() => this.setState({ popupTaxaVisivel: false })}
          dragEnabled={false}
          closeOnOutsideClick={false}
          showCloseButton={false}
          showTitle={true}
          width={"90%"}
          height={"90%"}
          title="Pesquisar Taxa"
        >
          <ScrollView showScrollbar={"always"}>
            <TaxasBox onSelecionado={this.onTaxaSelecionadoPesquisa} />
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ popupTaxaVisivel: false }),
            }}
          ></ToolbarItem>
        </Popup>
      </React.Fragment>
    );
  }

  ok() {
    try {
      showReport(
        `report/debitos_contribuintes/${UserInfo.getPrefeitura()}`,
        this.state
      );
      notify("Relatório emitido com sucesso", "success");
    } catch (err) {
      console.log(err);
    }
  }

  cancel() {
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
